import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useLocation } from "react-router-dom";
import { FaCheckCircle } from 'react-icons/fa';
import TopHeader from '../../Header/TopHeader';
import Navbar from '../../Header/Navbar';
import Footer from '../../Footer/Footer';
import Breadcrumb from '../../Screens/Breadcrumb';
import PopularService from '../PopularService';
import '../../Css/PropertiesShip.css';
import '../../Css/DocumentRequire.css';

import proprietorshipImg from '../../Images/proprietorship_hero_banner.png';
import partnershipImg from '../../Images/partnership_firm.png';
import llpImg from '../../Images/llp_registration.png';
import privateLtdImg from '../../Images/private_limited_company.png';
import onePersonImg from '../../Images/one_person_company.png';
import limitedCompanyImg from '../../Images/limited_company.png';
import nidhiCompanyImg from '../../Images/nidhi_company.png';
import coreInvestmentImg from '../../Images/core_investment_company.png';
import producerCompanyImg from '../../Images/producer_company.png';
import section8Img from '../../Images/section_8_company.png';
import trustImg from '../../Images/trust_registration.png';
import societyImg from '../../Images/society_registration.png';
import propertyImg from '../../Images/property_registration.png';
import caFirmImg from '../../Images/ca_firm.png';

// Dynamic banners
import fssai_registration from '../../Images/Banners/fssai_registration.png';
import trademark_registration from '../../Images/Banners/trademark_registration.png';
import iso_certification from '../../Images/Banners/iso_certification.png';
import company_law_compliance from '../../Images/Banners/company_law_compliance.png';
import llp_law_compliance from '../../Images/Banners/llp_law_compliance.png';
import din_application from '../../Images/Banners/din_application.png';
import epf_registration from '../../Images/Banners/epf_registration.png';
import esi_registration from '../../Images/Banners/esi_registration.png';
import esi_benefits from '../../Images/Banners/esi_benefits.png';
import business_planning from '../../Images/Banners/business_planning.png';
import business_loan from '../../Images/Banners/business_loan.png';
import cc_overdraft from '../../Images/Banners/cc_overdraft.png';
import personal_loan from '../../Images/Banners/personal_loan.png';

const getHeroImageFallback = (title) => {
    const slug = title?.toLowerCase().trim() || "";
    
    // Specific matches
    if (slug.includes('fssai') || slug.includes('food')) return fssai_registration;
    if (slug.includes('trademark') || slug.includes('brand') || slug.includes('copyright')) return trademark_registration;
    if (slug.includes('iso')) return iso_certification;
    if (slug.includes('company law') || slug.includes('add director') || slug.includes('remove director') || slug.includes('roc')) return company_law_compliance;
    if (slug.includes('llp law') || slug.includes('llp')) return llp_law_compliance;
    if (slug.includes('din') || slug.includes('dsc')) return din_application;
    if (slug.includes('epf') || slug.includes('pf') || slug.includes('provident')) return epf_registration;
    if (slug.includes('esi') && slug.includes('benefit')) return esi_benefits;
    if (slug.includes('esi') || slug.includes('state insurance')) return esi_registration;
    
    // Finance / Loan matches
    if (slug.includes('business planning') || slug.includes('msme') || slug.includes('udyog') || slug.includes('startup')) return business_planning;
    if (slug.includes('business loan')) return business_loan;
    if (slug.includes('cc') || slug.includes('overdraft')) return cc_overdraft;
    if (slug.includes('personal loan')) return personal_loan;
    
    // Extended mappings
    if (slug.includes('import') || slug.includes('export') || slug.includes('iec')) return company_law_compliance;
    if (slug.includes('tax') || slug.includes('audit') || slug.includes('gst')) return business_planning;
    if (slug.includes('license') || slug.includes('certification') || slug.includes('psara')) return iso_certification;
    if (slug.includes('legal') || slug.includes('law') || slug.includes('compliance')) return company_law_compliance;
    if (slug.includes('registration')) return iso_certification; // Generic registration fallback
    
    return company_law_compliance; // Absolute fallback
}

const getHeroImage = (isProprietorship, isPartnership, isLLP, isPvtLtd, isOPC, isLimitedCompany, isNidhi, isCoreInvestment, isProducerCompany, isSection8, isTrust, isSociety, isProperties, isCAFirm) => {
    if (isProprietorship) return proprietorshipImg;
    if (isPartnership) return partnershipImg;
    if (isLLP) return llpImg;
    if (isPvtLtd) return privateLtdImg;
    if (isOPC) return onePersonImg;
    if (isLimitedCompany) return limitedCompanyImg;
    if (isNidhi) return nidhiCompanyImg;
    if (isCoreInvestment) return coreInvestmentImg;
    if (isProducerCompany) return producerCompanyImg;
    if (isSection8) return section8Img;
    if (isTrust) return trustImg;
    if (isSociety) return societyImg;
    if (isProperties) return propertyImg;
    if (isCAFirm) return caFirmImg;
    return proprietorshipImg;
};


function Propitorship() {
    const { slug } = useParams();
    const location = useLocation();
    const id = location.state?.id;
    const serviceName = location.state?.serviceName;

    const [processData, setProcessData] = useState([]);
    const [serviceData, setServiceData] = useState({});
    const [servicesList, setServicesList] = useState([]);
    const [loading, setLoading] = useState(true);

    const getProcessData = async () => {
        try {
            const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/RegistrationProcessList?BusinessId=${id}`);
            setProcessData(data.data || []);
        } catch (error) {
            console.error("Error fetching process data:", error);
        }
    };

    const getServiceData = async () => {
        try {
            const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/ServiceDetailList?BusinessId=${id}`);
            setServiceData(data.id || {});
            setServicesList(data.services || []);
        } catch (error) {
            console.error("Error fetching service data:", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            if (id) {
                await Promise.all([getProcessData(), getServiceData()]);
            }
            setLoading(false);
        };
        fetchData();
    }, [id]);

    const title = serviceName || serviceData.serviceName || "Service Details";
    const isProprietorship = title.toLowerCase().includes('proprietor');
    const isPartnership = title.toLowerCase().includes('partnership');
    const isLLP = title.toLowerCase().includes('llp');
    const isPvtLtd = title.toLowerCase().includes('private limited') || title.toLowerCase().includes('pvt ltd') || title.toLowerCase().includes('pvt. ltd.');
    const isOPC = title.toLowerCase().includes('one person') || title.toLowerCase().includes('opc');
    const isLimitedCompany = !isPvtLtd && (title.toLowerCase().includes('limited') || title.toLowerCase().includes('ltd'));
    const isNidhi = title.toLowerCase().includes('nidhi');
    const isCoreInvestment = title.toLowerCase().includes('core investment');
    const isProducerCompany = title.toLowerCase().includes('producer');
    const isSection8 = title.toLowerCase().includes('section 8') || title.toLowerCase().includes('section8');
    const isTrust = title.toLowerCase().includes('trust');
    const isSociety = title.toLowerCase().includes('society');
    const isProperties = title.toLowerCase().includes('properties');
    const isCAFirm = title.toLowerCase().includes('ca firm');
    
    const isFinancialService = title.toLowerCase().includes('financial service');
    const heroImage = getHeroImage(isProprietorship, isPartnership, isLLP, isPvtLtd, isOPC, isLimitedCompany, isNidhi, isCoreInvestment, isProducerCompany, isSection8, isTrust, isSociety, isProperties, isCAFirm);
    const fallbackImage = getHeroImageFallback(title);

    return (
        <>
            <TopHeader />
            <Navbar />

            {isProprietorship ? (
                <div className="proprietorship-hero-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Start Your Business Journey with</span>
                                </div>
                                <h1 className="hero-main-heading">Proprietorship</h1>
                                <p className="hero-tagline mb-4">A Simple, Flexible & Powerful Business Structure</p>

                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-rocket-takeoff"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Easy Registration</h6>
                                            <small className="text-light-blue">Quick & Hassle-Free Process</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-person-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Full Control</h6>
                                            <small className="text-light-blue">100% Ownership and Decision Making</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-graph-up-arrow"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Low Compliance</h6>
                                            <small className="text-light-blue">Simple Legal & Tax Requirements</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isPartnership ? (
                <div className="proprietorship-hero-banner partnership-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Build & Grow Together with</span>
                                </div>
                                <h1 className="hero-main-heading">Partnership Firm</h1>
                                <p className="hero-tagline mb-4">Shared Ownership. Shared Responsibility. Shared Growth.</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-building"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Easy Formation</h6>
                                            <small className="text-light-blue">Simple Partnership Registration</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-people-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Shared Ownership</h6>
                                            <small className="text-light-blue">Collaborative Business Decisions</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-layers-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Flexible Structure</h6>
                                            <small className="text-light-blue">Suitable for Growing Businesses</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isLLP ? (
                <div className="proprietorship-hero-banner llp-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Protect Your Business While You</span>
                                </div>
                                <h1 className="hero-main-heading">LLP Registration</h1>
                                <p className="hero-tagline mb-4">Limited Liability with Flexible Management</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shield-check"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Limited Liability</h6>
                                            <small className="text-light-blue">Protect Personal Assets</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-diagram-3"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Flexible Management</h6>
                                            <small className="text-light-blue">Partners Manage the Business</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-building-check"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Separate Identity</h6>
                                            <small className="text-light-blue">Independent Legal Structure</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isPvtLtd ? (
                <div className="proprietorship-hero-banner pvt-ltd-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Build a Strong & Scalable</span>
                                </div>
                                <h1 className="hero-main-heading">Private Limited Company</h1>
                                <p className="hero-tagline mb-4">A Trusted Structure for Growing Businesses</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shield-check"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Limited Liability</h6>
                                            <small className="text-light-blue">Protect Your Personal Assets</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-building"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Separate Legal Entity</h6>
                                            <small className="text-light-blue">Independent Business Identity</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-cash-coin"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Easy Fundraising</h6>
                                            <small className="text-light-blue">Built for Business Growth</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isOPC ? (
                <div className="proprietorship-hero-banner opc-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Turn Your Idea Into a</span>
                                </div>
                                <h1 className="hero-main-heading">One Person Company</h1>
                                <p className="hero-tagline mb-4">Corporate Benefits. Single Ownership.</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-person"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Single Owner</h6>
                                            <small className="text-light-blue">Complete Business Control</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shield-lock"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Limited Liability</h6>
                                            <small className="text-light-blue">Protect Your Personal Assets</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-buildings"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Corporate Identity</h6>
                                            <small className="text-light-blue">Professional Business Structure</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isLimitedCompany ? (
                <div className="proprietorship-hero-banner limited-company-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Create a Strong & Reliable</span>
                                </div>
                                <h1 className="hero-main-heading">Limited Company</h1>
                                <p className="hero-tagline mb-4">Structured for Stability, Trust & Growth</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shield-check"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Limited Liability</h6>
                                            <small className="text-light-blue">Reduced Personal Financial Risk</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-building"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Separate Identity</h6>
                                            <small className="text-light-blue">Independent Legal Entity</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-award"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Business Credibility</h6>
                                            <small className="text-light-blue">Build Customer & Investor Trust</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isNidhi ? (
                <div className="proprietorship-hero-banner nidhi-company-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Build a Community of</span>
                                </div>
                                <h1 className="hero-main-heading">Nidhi Company</h1>
                                <p className="hero-tagline mb-4">Encouraging Savings & Mutual Financial Growth</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-people"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Member Focused</h6>
                                            <small className="text-light-blue">Serving Members Through Mutual Benefits</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-piggy-bank"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Savings Based</h6>
                                            <small className="text-light-blue">Promote Financial Discipline</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-card-checklist"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Regulated Structure</h6>
                                            <small className="text-light-blue">Structured for Member Activities</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isCoreInvestment ? (
                <div className="proprietorship-hero-banner core-investment-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Build & Manage Your</span>
                                </div>
                                <h1 className="hero-main-heading">Core Investment Company</h1>
                                <p className="hero-tagline mb-4">Structured Investment Management for Business Groups</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-graph-up-arrow"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Strategic Investment</h6>
                                            <small className="text-light-blue">Focus on Long-Term Growth</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-diagram-3-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Group Investments</h6>
                                            <small className="text-light-blue">Manage Strategic Business Holdings</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-boxes"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Structured Management</h6>
                                            <small className="text-light-blue">Organized Investment Framework</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isProducerCompany ? (
                <div className="proprietorship-hero-banner producer-company-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Empower Producers to</span>
                                </div>
                                <h1 className="hero-main-heading">Producer Company</h1>
                                <p className="hero-tagline mb-4">Collective Strength for Producer-Led Businesses</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-basket"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Producer Focused</h6>
                                            <small className="text-light-blue">Designed for Producer Communities</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-people"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Collective Growth</h6>
                                            <small className="text-light-blue">Work Together for Better Opportunities</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shop"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Better Market Access</h6>
                                            <small className="text-light-blue">Strengthen Business & Market Reach</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isSection8 ? (
                <div className="proprietorship-hero-banner section8-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Create an Organization for</span>
                                </div>
                                <h1 className="hero-main-heading">Section 8 Company</h1>
                                <p className="hero-tagline mb-4">Build an Organization with a Social Purpose</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Social Purpose</h6>
                                            <small className="text-light-blue">Focused on Community Development</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-building"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Non-Profit Structure</h6>
                                            <small className="text-light-blue">Purpose Driven Organization</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shield-check"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Credibility</h6>
                                            <small className="text-light-blue">Build Trust Through a Legal Structure</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isTrust ? (
                <div className="proprietorship-hero-banner trust-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Build a Foundation of</span>
                                </div>
                                <h1 className="hero-main-heading">Trust Registration</h1>
                                <p className="hero-tagline mb-4">Create a Structured Organization for a Purpose</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-heart-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Purpose Driven</h6>
                                            <small className="text-light-blue">Support Social & Charitable Objectives</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-bank"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Legal Structure</h6>
                                            <small className="text-light-blue">Create a Recognized Organization</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-tree-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Long-Term Impact</h6>
                                            <small className="text-light-blue">Build Sustainable Community Benefits</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isSociety ? (
                <div className="proprietorship-hero-banner society-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Bring People Together for a</span>
                                </div>
                                <h1 className="hero-main-heading">Society Registration</h1>
                                <p className="hero-tagline mb-4">Build a Community Around a Common Purpose</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-people-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Community Focused</h6>
                                            <small className="text-light-blue">Bring Members Together</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-boxes"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Organized Structure</h6>
                                            <small className="text-light-blue">Create a Legal Framework</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-bullseye"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Social Impact</h6>
                                            <small className="text-light-blue">Work Towards Common Objectives</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isProperties ? (
                <div className="proprietorship-hero-banner properties-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Manage Your Property Business with</span>
                                </div>
                                <h1 className="hero-main-heading">Properties</h1>
                                <p className="hero-tagline mb-4">Professional Property Management & Business Support</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-house-gear"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Property Management</h6>
                                            <small className="text-light-blue">Organize Your Property Activities</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-file-earmark-text"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Documentation</h6>
                                            <small className="text-light-blue">Keep Important Records Structured</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-briefcase"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Business Support</h6>
                                            <small className="text-light-blue">Simplify Property-Related Compliance</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isCAFirm ? (
                <div className="proprietorship-hero-banner ca-firm-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Build a Professional</span>
                                </div>
                                <h1 className="hero-main-heading">CA Firm</h1>
                                <p className="hero-tagline mb-4">Professional Accounting, Tax & Compliance Practice</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-briefcase"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Professional Practice</h6>
                                            <small className="text-light-blue">Build Your CA Practice</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-calculator"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Tax & Compliance</h6>
                                            <small className="text-light-blue">Manage Professional Responsibilities</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-award"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Client Trust</h6>
                                            <small className="text-light-blue">Create a Credible Professional Identity</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : isFinancialService ? (
                <div className="proprietorship-hero-banner financial-service-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className="col-lg-8 text-white text-start">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Build a Smarter</span>
                                </div>
                                <h1 className="hero-main-heading">Financial Service</h1>
                                <p className="hero-tagline mb-4">Professional Structure for Financial Businesses</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-wallet2"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Financial Management</h6>
                                            <small className="text-light-blue">Organize Your Financial Operations</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shield-check"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Compliance Support</h6>
                                            <small className="text-light-blue">Stay Structured & Compliant</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-graph-up-arrow"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Business Growth</h6>
                                            <small className="text-light-blue">Build Trust & Scale Your Services</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                <div className="hero-dynamic-image-wrapper">
                                    <img src={heroImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            ) : (
                <div className="proprietorship-hero-banner">
                    <div className="container h-100 position-relative z-index-2">
                        <div className="row h-100 align-items-center py-5">
                            <div className={fallbackImage ? "col-lg-8 text-white text-start" : "col-lg-12 text-white text-start"}>
                                <div className="d-flex align-items-center mb-2">
                                    <div className="hero-eyebrow-line"></div>
                                    <span className="hero-eyebrow-text ms-2">Start Your Business Journey with</span>
                                </div>
                                <h1 className="hero-main-heading">{title}</h1>
                                <p className="hero-tagline mb-4">Fast, Secure & Hassle-Free Services</p>
                                
                                <div className="hero-features-container mt-4">
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-rocket-takeoff"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Easy Registration</h6>
                                            <small className="text-light-blue">Quick & Hassle-Free Process</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-person-fill"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Full Control</h6>
                                            <small className="text-light-blue">100% Ownership & Decisions</small>
                                        </div>
                                    </div>
                                    <div className="hero-feature-card">
                                        <div className="hero-feature-icon">
                                            <i className="bi bi-shield-check"></i>
                                        </div>
                                        <div className="hero-feature-text">
                                            <h6 className="mb-0 text-white fw-bold">Secure Compliance</h6>
                                            <small className="text-light-blue">Fully Legal & Tax Ready</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* RIGHT SIDE (IMAGE) */}
                            {fallbackImage && (
                                <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center position-relative">
                                    <div className="hero-dynamic-image-wrapper">
                                        <img src={fallbackImage} alt={title} className="img-fluid" style={{ maxHeight: '420px', objectFit: 'contain', zIndex: 5, position: 'relative', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.5))', borderRadius: '15px' }} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Background decorations */}
                    <div className="hero-bg-glow"></div>
                    <div className="hero-bg-wave"></div>
                </div>
            )}


            <style dangerouslySetInnerHTML={{
                __html: `
                        .proprietorship-hero-banner {
                            background: linear-gradient(135deg, #09304e 0%, #0d4670 100%);
                            position: relative;
                            overflow: hidden;
                            min-height: 450px;
                            display: flex;
                            align-items: center;
                        }
                        .hero-bg-glow {
                            position: absolute;
                            top: -20%;
                            left: 10%;
                            width: 600px;
                            height: 600px;
                            background: radial-gradient(circle, rgba(137, 199, 100, 0.15) 0%, rgba(0,0,0,0) 70%);
                            z-index: 1;
                        }
                        .hero-bg-wave {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 100px;
                            background: url('data:image/svg+xml;utf8,<svg viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg"><path fill="%2389c764" fill-opacity="0.2" d="M0,256L80,245.3C160,235,320,213,480,213.3C640,213,800,235,960,240C1120,245,1280,235,1360,229.3L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>') no-repeat bottom;
                            background-size: cover;
                            z-index: 1;
                        }
                        .z-index-2 {
                            z-index: 2;
                        }
                        .hero-eyebrow-line {
                            width: 40px;
                            height: 2px;
                            background-color: #89c764;
                        }
                        .hero-eyebrow-text {
                            font-size: 1.1rem;
                            color: #f1f5f9;
                            letter-spacing: 0.5px;
                        }
                        .hero-main-heading {
                            font-size: 3.2rem; white-space: nowrap;
                            font-weight: 800;
                            color: #ffffff;
                            text-shadow: 0 4px 15px rgba(0,0,0,0.2);
                            margin: 5px 0 10px 0;
                            line-height: 1.1;
                        }
                        .hero-tagline {
                            font-size: 1.3rem;
                            color: #e2e8f0;
                            font-weight: 500;
                        }
                        .text-lime {
                            color: #89c764;
                        }
                        .text-light-blue {
                            color: #cbd5e1;
                            font-size: 0.85rem;
                        }
                        .hero-breadcrumb {
                            font-size: 0.95rem;
                            color: #cbd5e1;
                        }
                        .hero-features-container {
                            display: flex;
                            gap: 15px;
                            flex-wrap: nowrap;
                        }
                        .hero-feature-card {
                            background: rgba(13, 70, 112, 0.6);
                            border: 1px solid rgba(137, 199, 100, 0.3);
                            backdrop-filter: blur(10px);
                            border-radius: 12px;
                            padding: 10px 12px;
                            display: flex;
                            align-items: center;
                            gap: 15px;
                            flex: 1;
                            min-width: 0;
                            transition: transform 0.3s ease, background 0.3s ease;
                        }
                        .hero-feature-card:hover {
                            transform: translateY(-5px);
                            background: rgba(13, 70, 112, 0.9);
                            border-color: #89c764;
                        }
                        .hero-feature-icon {
                            font-size: 20px;
                            color: #89c764;
                            background: rgba(137, 199, 100, 0.1);
                            width: 40px;
                            height: 40px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 50%;
                            flex-shrink: 0;
                            border: 1px solid rgba(137, 199, 100, 0.2);
                        }
                        .hero-right-illustration {
                            animation: floatImage 6s ease-in-out infinite;
                            max-height: 420px;
                            object-fit: contain;
                            filter: drop-shadow(0 20px 30px rgba(0,0,0,0.3));
                        }
                        @keyframes floatImage {
                            0% { transform: translateY(0px); }
                            50% { transform: translateY(-15px); }
                            100% { transform: translateY(0px); }
                        }
                        @media (max-width: 991px) {
                            .hero-features-container { flex-wrap: wrap; }
                            .hero-feature-card { min-width: 200px; }
                            .hero-main-heading { font-size: 2.2rem; white-space: normal; word-break: keep-all; }
                        }
                    `}} />


            <div className="service-page-wrapper py-5">
                <div className="container">
                    <div className="row g-4">
                        {/* MAIN CONTENT (FULL WIDTH) */}
                        <div className="col-lg-12">

                            {/* Title and Description */}
                            <div className="service-detail-card mb-4">
                                <h2 className="service-title">{title}</h2>
                                <hr className="title-divider" />
                                <div
                                    className="service-description"
                                    dangerouslySetInnerHTML={{ __html: serviceData.proprietorshipDescription || '' }}
                                ></div>
                            </div>

                            {/* Pricing Overview */}
                            <div className="pricing-summary-card mb-4">
                                <div className="row text-center">
                                    <div className="col-md-4 pricing-item">
                                        <p className="text-muted mb-1">Market Price</p>
                                        <h4 className="text-decoration-line-through text-danger">₹{serviceData.marketPrice || '0'}.00</h4>
                                    </div>
                                    <div className="col-md-4 pricing-item border-start border-end">
                                        <p className="text-muted mb-1">Our Price</p>
                                        <h4 className="text-success fw-bold">₹{serviceData.price || '0'}.00</h4>
                                    </div>
                                    <div className="col-md-4 pricing-item">
                                        <p className="text-muted mb-1">You Save</p>
                                        <h4 className="text-primary fw-bold">₹{serviceData.savePrice || '0'}.00</h4>
                                    </div>
                                </div>
                            </div>

                            {/* Included Services List */}
                            {servicesList && servicesList.length > 0 && (
                                <div className="included-services-card mb-4">
                                    <h4 className="fw-bold mb-3">Package Includes</h4>
                                    <div className="row g-3">
                                        {servicesList.map((item, index) => (
                                            <div className="col-md-6 d-flex align-items-center" key={index}>
                                                <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                                                <span>{item.service}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    {/* Registration Process Grid */}
                    {processData && processData.length > 0 && (
                        <div className="process-grid-wrapper mt-5 mb-4">
                            <h4 className="fw-bold mb-4 text-center" style={{ color: "#115886" }}>Registration Process</h4>
                            <div className="process-grid-container">
                                {processData.map((step, index) => {
                                    const processImages = [
                                        "https://assets.vakilsearch.com/expert.svg",
                                        "https://assets.vakilsearch.com/docu.svg",
                                        "https://assets.vakilsearch.com/docu.svg",
                                        "https://assets.vakilsearch.com/certificate.svg"
                                    ];
                                    const imgUrl = processImages[index % processImages.length];
                                    return (
                                        <div className="process-grid-card" key={index}>
                                            <div className="grid-img-wrapper">
                                                <img src={imgUrl} alt="Process Step" />
                                            </div>
                                            <span className="grid-day-badge">{step.days || `Day ${index + 1} - ${index + 2}`}</span>
                                            <div className="grid-html-content" dangerouslySetInnerHTML={{ __html: step?.registrationProcess || '' }}></div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <PopularService />
            <Footer />
        </>
    );
}

export default Propitorship;